import type {
  Dataset,
  DatasetCommonData,
  DatasetsSortByDateProps,
  DatasetType,
} from "./dataset.type";

import { groupBy } from "@/utilities/array";
import { sortDates } from "@/utilities/date";

export const groupDatasetsByType = (datasets: Dataset[] = []) => {
  return groupBy<Dataset, DatasetType>(datasets, ({ type }) => type);
};

export const sortDatasetsByDate = <T extends DatasetCommonData>({
  datasets = [],
  property,
  order = "asc",
}: DatasetsSortByDateProps<T>): T[] => {
  type DateKey = keyof Pick<DatasetCommonData, "created_at" | "updated_at">;
  const dateProperty = property as DateKey;

  return [...datasets].sort((datasetA, datasetB) => {
    return sortDates(datasetA[dateProperty], datasetB[dateProperty], order);
  });
};
